import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { AnswersOptionsVM } from '../../../Training/setup-training-types.model'
import { InterpretationService } from '../../interpretation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewInspectionService } from '../../../inspection/services/new-inspection.service';

@Component({
  selector: 'app-additional-component-answer',
  templateUrl: './additional-component-answer.component.html',
  styleUrls: ['./additional-component-answer.component.scss']
})
export class AdditionalComponentAnswerComponent implements OnInit {

  AdditionalObsId: number;
  AdditionalObsRefId: number;
  AnswerList:AnswersOptionsVM[];
  QuestionTypeId:number;
  isCreateNew: boolean = false;
  startWorn: number;
  endWorn: number;
  noOfDecimal: number;
  isCreateNewSP: boolean = false;

  constructor( public dialogRef: MatDialogRef<AdditionalComponentAnswerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _interp: InterpretationService,
    private _loading: LoadingService,
    private _inspectionService: NewInspectionService,  ) { }

  ngOnInit() {
    this.AdditionalObsId = this.data.InspectionAdditionalObsId;
    this.AdditionalObsRefId = this.data.AdditionalObsRefId;
    this.AnswerList = this.data.AnswerList;
    this.QuestionTypeId=this.data.QuestionTypeId;
    this.isCreateNew = this.data.isCreateNew;
    this.isCreateNewSP = this.data.isCreateNewSP;
    if (this.QuestionTypeId == 5)
      this.loadModelAddtionalObservationInfo();
  }

  onAnswerSelected(answer: AnswersOptionsVM) {
    if (this.QuestionTypeId === 1 || this.QuestionTypeId === 2) {
      // For type 1, update the userSelectAnswer property of the selected answer
      this.AnswerList.forEach((ans: AnswersOptionsVM) => {
        ans.UserSelect = ans === answer;
      });
    } else if (this.QuestionTypeId === 3) {
      // For type 2, toggle the userSelectAnswer property of the selected answer
      answer.UserSelect = !answer.UserSelect;
    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }


  AddupdateAdditionalObsAnswer(){
    console.log("AnswerList",this.AnswerList);
    this.AnswerList.forEach((ans: AnswersOptionsVM) => {
      ans.Id = this.AdditionalObsId;
    });


    if(this.QuestionTypeId==4 || this.QuestionTypeId==5){
      this.AnswerList.forEach((ans: AnswersOptionsVM) => {
       if(ans.Name!="" ||ans.Name!=undefined){
        ans.UserSelect=true;
       }
      });
    }
    if(this.isCreateNew==false){
      
  this._interp.UpdateInspectionAdditionalObsAnswer(this.AnswerList).subscribe(res=>{
    if(res){
      this.dialogRef.close(true);
    }else{
      this.dialogRef.close(false);
    }
  })
    }
    else{
      if(!this.isCreateNewSP){
        this._interp.UpdateObservationListDraftAnswer(this.AnswerList).subscribe(res=>{
        if(res){
          this.dialogRef.close(true);
        }else{
          this.dialogRef.close(false);
        }
      })
      }
      else {
           this.dialogRef.close({AnswerList: this.AnswerList, close: true});
      }


    }
    

  }

  private loadModelAddtionalObservationInfo() {
    this._inspectionService.getAdditionalObservationInfo(this.AdditionalObsRefId).subscribe(r => {
      if (r) {
        this.noOfDecimal = (r.NoOfDecimal !== undefined && r.NoOfDecimal !== null) ? r.NoOfDecimal : 0;
        this.startWorn = r.Worn0percent;
        this.endWorn = r.Worn100percent;
        console.log("this.noOfDecimal", this.noOfDecimal, this.startWorn, this.endWorn);
        if (this.AnswerList.length > 0 && this.AnswerList[0].Name != null && this.AnswerList[0].Name != '') {
          const num = parseFloat(this.AnswerList[0].Name);
          if (!isNaN(num)) {
            this.AnswerList[0].Name = num.toFixed(this.noOfDecimal);
          }
        }
      }
    });
  }

  onDecimalInput(event: Event) {
    const input = event.target as HTMLInputElement;

    // Let the browser update the value first
    setTimeout(() => {
      const value = input.value;
      const selectionStart = input.selectionStart || 0;

      // Allow digits + optional "." + up to N decimal places
      const regex = new RegExp(`^\\d*(\\.\\d{0,${this.noOfDecimal}})?$`);

      if (regex.test(value)) {
        // Valid input — do nothing
        return;
      }

      // Try to match the valid portion
      const match = value.match(new RegExp(`^\\d*(\\.\\d{0,${this.noOfDecimal}})?`));
      if (match) {
        const newValue = match[0];
        input.value = newValue;

        // Restore cursor as best as possible
        const newCursorPos = Math.min(selectionStart - 1, newValue.length);
        input.setSelectionRange(newCursorPos, newCursorPos);
      } else {
        input.value = '';
      }
    }, 0);
  }

  formatToDecimals(answer: AnswersOptionsVM) {
    if (answer?.Name != null && answer?.Name != '') {
      answer.Name = parseFloat(answer.Name).toFixed(this.noOfDecimal);
    }
  }


}
